<template>
  <div class="refund">
    <el-tabs v-model="activeName">
      <el-tab-pane label="储值卡退卡" name="card">
        <RefundCard v-if="activeName === 'card'"></RefundCard>
      </el-tab-pane>
      <el-tab-pane label="储值卡退卡订单管理" name="order">
        <RefundOrder v-if="activeName === 'order'"></RefundOrder>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RefundCard from './RefundCard.vue';
import RefundOrder from './RefundOrder.vue';

export default {
  data () {
    return {
      activeName: 'card'
    };
  },
  components: { RefundCard, RefundOrder },
  created () {

  },
  methods: {

  },
};
</script>

<style scoped lang='scss'>
  .refund {
    background-color: #fff;
    padding: 20px;
  }
</style>